export function getCsrfToken(): string {
  return (
    document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')?.toString() || ''
  );
}

export async function csrfFetch(input: RequestInfo | URL, init: RequestInit = {}) {
  const csrf = getCsrfToken();
  const headers = new Headers(init.headers || {});
  if (!headers.has('X-CSRF-Token')) {
    headers.set('X-CSRF-Token', csrf);
  }
  if (!headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  return fetch(input, { ...init, headers, credentials: init.credentials || 'include' });
}
